import Cart from 'thd-cart-bindings';
import { window } from '../../../utils';

function initAddToCart(isMobile: boolean, atcRequest: ATCRequest) {
  const channel = isMobile ? 'mobile' : 'desktop';
  const ignoreThrottle = true;
  const host = `https://${window.hostName()}`;
  const subscription = !!(atcRequest && atcRequest.subscriptions);
  const frequency = atcRequest.subscriptions ? atcRequest.subscriptions.frequency : '6_3';
  const ogModule = atcRequest.subscriptions ? atcRequest.subscriptions.ogModule : "pdp_nocontent";

  Cart.addToCart(atcRequest, {
    host,
    channel,
    ignoreThrottle,
    subscription,
    frequency,
    ogModule
  })
}

export default initAddToCart;
